import { render, staticRenderFns } from "./pageable.vue?vue&type=template&id=3213e56c"
import script from "./pageable.vue?vue&type=script&lang=js"
export * from "./pageable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports